export const SUBSPLASH_AUTH_PROVIDER_ID =
  '19bc7532-7e56-440c-bd2e-171026dd5195';
